const AUTH_STORAGE_KEY = 'auth-storage';

interface AuthStorageState {
  state: {
    accessToken: string | null;
    refreshToken: string | null;
    user: unknown;
    isAuthenticated: boolean;
  };
  version?: number;
}

export function getAccessToken(): string | null {
  try {
    const stored = localStorage.getItem(AUTH_STORAGE_KEY);
    if (!stored) return null;
    const parsed: AuthStorageState = JSON.parse(stored);
    return parsed.state?.accessToken || null;
  } catch {
    return null;
  }
}

export function getRefreshToken(): string | null {
  try {
    const stored = localStorage.getItem(AUTH_STORAGE_KEY);
    if (!stored) return null;
    const parsed: AuthStorageState = JSON.parse(stored);
    return parsed.state?.refreshToken || null;
  } catch {
    return null;
  }
}

export function updateTokensInStorage(
  accessToken: string,
  refreshToken: string,
): void {
  try {
    const stored = localStorage.getItem(AUTH_STORAGE_KEY);
    if (!stored) return;
    const parsed: AuthStorageState = JSON.parse(stored);
    parsed.state.accessToken = accessToken;
    parsed.state.refreshToken = refreshToken;
    localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(parsed));
  } catch {
    // Silently fail
  }
}

export function clearAuthStorage(): void {
  localStorage.removeItem(AUTH_STORAGE_KEY);
}
